import styled from 'styled-components';
import { lightTheme } from '../../themes';

export const List = styled.div`
  margin: 20px auto;
  min-height: calc(100vh - 270px);
  position: relative;
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0px;
`;
export const THead = styled.thead`
  background-color: ${lightTheme.palette.primary.light};
  border: 3px solid #f0f0ff;
  border-bottom-width: 10px;
`;
export const TBody = styled.tbody`
  margin-top: 10px;
`;
export const TR = styled.tr``;
export const TH = styled.th`
  padding: 15px 10px;
  font-size: 11px;
  color: #fff;
  font-family: 'AvenirNextLTPro-Heavy';
  font-style: normal;
  text-transform: uppercase;
  font-weight: normal;
  position: relative;
  background-color: ${lightTheme.palette.primary.light};
  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
  &.th-1 {
    width: 15%;
  }
  &.th-2 {
    width: 30%;
  }
  &.th-3 {
    width: 30%;
  }
  &.th-4 {
    width: 25%;
  }
  &.tick {
    background-color: rgba(136, 127, 255, 0.1);
  }
`;
export const TD = styled.td`
  font-size: 12px;
  color: rgb(74, 74, 74);
  font-family: AvenirNext;
  font-weight: 500;
  font-style: normal;
  background-color: #fff;
  border: 3px solid ${lightTheme.colorTokens.surface};
  position: relative;
  &.tick {
    background-color: ${lightTheme.colorTokens.secondaryContainer};
  }
`;
export const Text = styled.div`
  margin-bottom: 5px;
  font-family: 'AvenirNext-Medium';
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  word-break: break-word;
  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const Name = styled.span`
  &.text-blur {
    color: transparent;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  }
`;

export const TextBold = styled(Text)`
  font-family: 'AvenirNext-DemiBold';
`;
export const Label = styled(Text)`
  font-size: 10px;
  font-family: 'AvenirNext-Medium';
  color: #9b9b9b;
`;
export const Box = styled.div`
  &:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid transparent;
  }
  &.tick {
    &:after {
      border: 1px solid ${(props) => props.color};
    }
  }
`;
export const Link = styled.span`
  cursor: pointer;
  font-family: 'AvenirNext-Medium';
  font-size: 10px;
  font-weight: 500;
  letter-spacing: -0.1px;
  text-align: center;
  color: #9b9b9b;
`;

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #b7b2f5;
`;

export const SearchHeaderCell = styled.div`
  padding: 10px;
  font-weight: bold;
  color: white;
  text-align: left;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: top;
  margin-top: 2px;
  margin-bottom: 2px;
`;

export const Col = styled.div`
  padding: 6px;
  margin: 2px;
  background-color: white;
  min-height: 40px;
  text-align: left;
  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;
export const Logo = styled.img``;
export const LogoContain = styled.div`
  margin: -10px;
  line-height: 0;
`;
export const Icon = styled.span`
  display: inline-block;
  margin-right: 10px;
  color: ${lightTheme.palette.primary.light};
`;
export const Button = styled.button`
  border: none;
  background: none;
  outline: none;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
  width: 15px;
  height: 15px;
`;

export const IconImage = styled.img`
  width: 15px;
  height: auto;
`;

// Bulk Search Styles
export const BulkSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
`;

export const BulkSearchInputRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
`;

export const BulkSearchTextArea = styled.textarea`
  flex: 1;
  min-height: 100px;
  padding: 12px;
  font-family: 'AvenirNext';
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: ${lightTheme.palette.primary.main};
  }
  &::placeholder {
    color: #9b9b9b;
  }
`;

export const IdTypeSelectContainer = styled.div`
  min-width: 160px;
`;

export const LimitWarning = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  margin-bottom: 10px;
  font-family: 'AvenirNext-Medium';
  font-size: 13px;
  color: #856404;
`;

export const WarningIcon = styled.span`
  margin-right: 8px;
  font-size: 16px;
`;

export const BulkSearchHelperText = styled.div`
  font-family: 'AvenirNext';
  font-size: 11px;
  color: #9b9b9b;
  margin-top: 4px;
`;

export default {
  colorStatus: {
    ASSIGNED: '#5a5a5a',
    CANCELLED_AFTER_PICKUP: '#d0021b',
    CANCELLED_BEFORE_PICKUP: '#d0021b',
    CREATED: '#5a5a5a',
    DELIVERED: '',
    DELIVERY_FAILED: '#d0021b',
    DROPOFF_DELAY: '',
    DROPOFF_EN_ROUTE: '',
    DROPOFF_FAILED: '#d0021b',
    DROPOFF_READY: '',
    DROPOFF_SUCCEEDED: '#4abc4e',
    EN_ROUTE: '',
    GEOCODED: '#5a5a5a',
    GEOCODE_FAILED: '#d0021b',
    GEOCODE_FAILED_DROPOFF: '#d0021b',
    GEOCODE_FAILED_PICKUP: '#d0021b',
    GEOCODE_FAILED_WITH_SUGGESTIONS: '#d0021b',
    PENDING: '#f5a623',
    PICKUP_DELAY: '#f5a623',
    PICKUP_EN_ROUTE: '',
    PICKUP_FAILED: '#d0021b',
    PICKUP_READY: '',
    PICKUP_SUCCEEDED: '#f5a623',
    REATTEMPT_DELIVERED: '',
    REATTEMPT_DELIVERY_FAILED: '#d0021b',
    REATTEMPT_EN_ROUTE: '',
    REATTEMPTING: '',
    RECEIVED: '',
    RETURN_DELAY: '',
    RETURN_EN_ROUTE: '',
    RETURN_READY: '',
    RETURN_SUCCEEDED: '#4abc4e',
  },
  center: {
    textAlign: 'center',
  },
  left: {
    textAlign: 'left',
  },
  right: {
    textAlign: 'right',
  },
  colCenter: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  colStart: {
    justifyContent: 'flex-start',
  },
  colWhite: {
    backgroundColor: '#FFF',
  },
  icon: {
    padding: 0,
    width: 15,
    height: 15,
  },
  iconStyle: {
    left: 0,
  },
  modalContainer: {
    display: 'flex',
    zIndex: 999,
    height: '100%',
  },
  modalStyle: {
    width: '480px',
    display: 'block',
    overflow: 'initial',
    backgroundColor: 'transparent',
    margin: 'auto',
    boxShadow: 'none',
  },
  modalImageStyle: {
    width: '650px',
    backgroundColor: '#FFF',
    padding: '30px 0',
  },
  wrapImages: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    position: 'relative',
    zIndex: 999,
  },
  imageShipment: {
    width: 'auto',
    maxWidth: '100%',
    // maxHeight: '100%',
    maxHeight: 'calc(100vh - 100px)',
    margin: 'auto',
    backgroundColor: '#FFFF',
    zIndex: 999,
  },
  arrowButton: {
    width: '30px',
    height: '30px',
    backgroundColor: '#000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: 'auto',
    zIndex: 10000,
    cursor: 'pointer',
  },
  arrowPrev: {
    left: 0,
  },
  arrowNext: {
    right: 0,
  },
  arrowIcon: {
    fontSize: '25px',
    color: '#fff',
  },
  panel: {
    position: 'relative',
    zIndex: 1,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: 'rgba(0,0,0,0.3)',
    paddingTop: 60,
  },
  textBlur: {
    color: 'transparent',
    textShadow: '0 0 10px rgba(0,0,0,0.6)',
  },
};
